import { connect } from 'react-redux'
import { createNewForm } from '../actions/formList'
import CreateNew from '../components/CreateNew'

const mapStateToProps = state => ({
    userId: state.main.userId
})

const mapDispatchToProps = (dispatch) => ({
    add: (userId) => dispatch(createNewForm(userId))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateNew)